import { render, staticRenderFns } from "./BuildingDataComponent.vue?vue&type=template&id=3ce79c7c&"
import script from "./BuildingDataComponent.vue?vue&type=script&lang=js&"
export * from "./BuildingDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports